import { get } from 'lodash';
import qs from 'qs';
import { getReferrerDetails } from 'utils/extractReferrerDetails';
import { extractQueryParameter } from 'utils/utility';
import { getValidProducts } from 'helpers/validProducts/validProducts';
import {
  REGIONS,
  STEP_PATH,
  SUBSCRIPTION_TYPE,
  getThemeByProductId,
  FEATURE_TOGGLE
} from '../../../constants';
import { SessionApply, SessionPredicate } from '../sessionType';

export const hasCheckoutSession: SessionPredicate = (history) => {
  const { search, pathname } = history.location;
  const splitPathname = pathname.split('/');
  const region = splitPathname[1];

  const hasValidRegion = region && Object.values(REGIONS).includes(region.toUpperCase());
  if (!hasValidRegion) return false;

  const queryString = qs.parse(search, { ignoreQueryPrefix: true });
  const productId = get(queryString, 'productId') as string;
  const activationCode = get(queryString, 'activationCode') as string;
  const hasRequiredParams = Boolean(productId) || Boolean(activationCode);
  if ([
    STEP_PATH.TRIAL.ROOT,
    STEP_PATH.SUBSCRIBE.ROOT,
    STEP_PATH.NEW_TRIAL.ROOT
  ].some((path) => pathname.includes(path)) &&
    hasRequiredParams) {
    return true;
  }

  return [
    STEP_PATH.SUBSCRIBE.PAYMENT,
    STEP_PATH.SUBSCRIBE.CONFIRMATION,
    STEP_PATH.TRIAL.CONFIRMATION,
    STEP_PATH.TRIAL.DUPLICATE,
    STEP_PATH.NEW_TRIAL.CONFIRMATION
  ].some((path) => pathname.includes(path));
};

export const updateCheckoutSession: SessionApply = (history, setState, attributes ) => {
  const { search, pathname } = history.location;
  const queryString = qs.parse(search, { ignoreQueryPrefix: true });
  const productId = get(queryString, 'productId') as string;
  const addOnIds = extractQueryParameter(queryString, 'addonId');
  const { addonIds } = getValidProducts(productId, addOnIds);
  const activationCode = get(queryString, 'activationCode') as string;
  const referrerDetails = getReferrerDetails(queryString);
  const pc = get(queryString, 'pc', '') as string;
  const splitPathname = pathname.split('/');
  const region = splitPathname[1];
  const isAnnualRoute = splitPathname.includes('annual') || get(queryString, 'use-annual') === 'true';
  let subscriptionType = SUBSCRIPTION_TYPE.TRIAL;
  const { isFeatureEnabled } = attributes;
  const isFrontBookLive = isFeatureEnabled(FEATURE_TOGGLE.FRONT_BOOK_LIVE);
  const isStrategicBedrockLive = isFeatureEnabled(FEATURE_TOGGLE.BEDROCK_STRATEGIC_PARTNER);
  const isBedrockSoloReferralsLive = isFeatureEnabled(FEATURE_TOGGLE.BEDROCK_SOLO_REFERRALS);

  if (pathname.includes(STEP_PATH.SUBSCRIBE.ROOT)) {
    subscriptionType = SUBSCRIPTION_TYPE.SUBSCRIBE;
  } else if (pathname.includes(STEP_PATH.NEW_TRIAL.ROOT)) {
    subscriptionType = SUBSCRIPTION_TYPE.NEW_TRIAL;
  }
  setState({
    region: region.toUpperCase(),
    subscriptionType,
    productId,
    pc,
    isAnnualRoute,
    theme: getThemeByProductId(productId, addonIds),
    activationCode,
    referrerDetails: referrerDetails,
    useLegacy: (Boolean(referrerDetails) && !isBedrockSoloReferralsLive) ||
               (Boolean(activationCode) && !isStrategicBedrockLive) ||
               !isFrontBookLive,
    addonIds
  });
};
